/* eslint-disable react/no-unstable-nested-components */
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { emplomentStyles as classes } from './EmploymentStyles';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { REQUIRED } from '../../../constants';
import { CommonStyles } from '../CommonStyles';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';
import { isBundle } from '../../commonCode';

function Reason(props) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme, productName } = leadGenerationContext;
  const commonStyles = CommonStyles(leadGenerationContext?.theme);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const { handleChange, isBundleCompliance = false } = props;

  return (
    <>
      <InputLabel
        htmlFor="reason"
        required={!isBundleCompliance}
        id="reason_label"
        data-testid="reason_label"
        aria-label={`${t('Reason', { defaultValue: 'Reason' })} ${t(REQUIRED, {
          defaultValue: REQUIRED,
        })}`}
        sx={commonStyles.label_title}
      >
        <span
          style={{
            color:
              isBundle(productName) && leadGenerationContext.employmentInformationErrors?.reason
                ? 'red'
                : 'inherit',
          }}
        >
          {t('Reason', { defaultValue: 'Reason' })}
        </span>
      </InputLabel>
      <Select
        id="reason"
        name="reason"
        role="listbox"
        data-testid="select_testid"
        fullWidth
        IconComponent={() => (
          <Box
            padding="0 10px 0 0"
            style={{
              top: 'calc(50% - 13px)',
              right: '10px',
              position: 'absolute',
            }}
          >
            <DownArrowIcon
              style={{
                width: 24,
                height: 24,
              }}
              color={theme?.palette?.orientalPrimary?.main}
            />
          </Box>
        )}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            sx: {
              ...theme?.menuBackground,
              border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
              color: theme?.palette?.primary?.main,
            },
            className: isBundle(productName) ? 'bundle-menu-paper' : '',
          },
        }}
        aria-label={t('Reason Aria Label', {
          defaultValue: 'Reason Required Please Select Reason dropdown menu button',
        })}
        variant="outlined"
        onChange={handleChange}
        // sx={[
        //   classes.select_inputs,
        //   leadGenerationContext.employmentInformationErrors?.reason &&
        //     !isBundleCompliance &&
        //     classes.select_inputs_err,
        //   leadGenerationContext.employmentInformationErrors?.reason &&
        //     isBundleCompliance &&
        //     classes.select_inputs_err_bundle,
        //   !leadGenerationContext.employmentInformation?.reason && {
        //     color: '#808285',
        //   },
        //   ...(isBundleCompliance && [
        //     classes.select_inputs_bundleBorder,
        //     commonStyles.outlined_input_bundle,
        //   ]),
        // ]}
        sx={[
          classes.select_inputs,
          leadGenerationContext.employmentInformationErrors?.reason && !isBundleCompliance
            ? classes.select_inputs_err
            : null,
          leadGenerationContext.employmentInformationErrors?.reason && isBundleCompliance
            ? classes.select_inputs_err_bundle
            : null,
          !leadGenerationContext.employmentInformation?.reason ? { color: '#808285' } : null,
          ...(isBundleCompliance
            ? [
                {
                  '&.Mui-focused': {
                    border: `1px solid ${theme?.palette?.primary?.main}`,
                  },
                },
                classes.select_inputs_bundleBorder,
                commonStyles.outlined_input_bundle,
                {
                  backgroundColor: leadGenerationContext.employmentInformationErrors?.reason
                    ? '#D5151F1A'
                    : theme?.palette?.fieldsBackground?.main,
                  // border: leadGenerationContext.employmentInformationErrors?.reason
                  //   ? `2px solid ${theme?.palette?.danger?.main}`
                  //   : `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  color: !leadGenerationContext.employmentInformation?.reason
                    ? theme?.palette?.fieldsPlaceholder?.main
                    : theme?.palette?.primary?.main,
                },
              ]
            : []),
        ]}
        slotProps={{
          icon: {
            sx: classes.select_icon,
          },
          select: {
            sx:
              !leadGenerationContext.employmentInformation?.reason ||
              leadGenerationContext.employmentInformation?.reason === 'Please select a reason'
                ? classes.select_inputs_placeholder
                : classes.select_style,
          },
        }}
        displayEmpty
        value={
          leadGenerationContext.employmentInformation?.reason
            ? leadGenerationContext.employmentInformation.reason
            : ''
        }
      >
        <MenuItem role="option" value="">
          {isBundleCompliance
            ? t('Select the reason', { defaultValue: 'Select the reason' })
            : t('Please select a reason', { defaultValue: 'Please select a reason' })}
        </MenuItem>
        {isBundleCompliance && (
          <MenuItem role="option" value="Not Currently Employed">
            {t('Unemployed', { defaultValue: 'Unemployed' })}
          </MenuItem>
        )}
        <MenuItem role="option" value="Student">
          {t('Student', { defaultValue: 'Student' })}
        </MenuItem>
        <MenuItem role="option" value="No Previous Employer">
          {t('No Previous Employer', { defaultValue: 'No Previous Employer' })}
        </MenuItem>
        {!isBundleCompliance && (
          <MenuItem role="option" value="Not Currently Employed">
            {t('Not Currently Employed', { defaultValue: 'Not Currently Employed' })}
          </MenuItem>
        )}
      </Select>
      <Box component="span" sx={styledClasses.error_message_product} role="alert">
        {t(leadGenerationContext.employmentInformationErrors?.reason, {
          defaultValue: leadGenerationContext.employmentInformationErrors?.reason,
        })}
      </Box>
    </>
  );
}

export default Reason;

Reason.propTypes = {
  handleChange: PropTypes.func,
  isBundleCompliance: PropTypes.bool,
};
